import { Constant, Headers } from "../apiConstants";

export const GetDineInOutletsListAPI = async (cityName, locationName) => {
  const endpoint = Constant.GET_DINEIN_OUTLETS + `?city=${cityName}&location=${locationName}`;
  const BaseUrl = Constant.BASE_URL;
  // console.log("Explore Page URL :",BaseUrl+"/"+endpoint)
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GetDineInOutletsAPI = async (localityData) => {
  const endpoint = Constant.GET_DINEIN_OUTLETS;
  const BaseUrl = Constant.BASE_URL;
  try {
    const body = {
      resturantType: ""
    };

    // Conditionally add the `cities` key if `localityData` is not an empty string
    if (localityData.trim() !== "") {
      body.cities = JSON.parse(localityData);
    }

    // console.log("Request Body :", body)
    // console.log("Passed Data :", localityData)

    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify(body),
      // body: JSON.stringify({
      //   resturantType: "",
      //   cities: localityData
      // }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GetOutletsTypeAPI = async (categoryName, localities) => {
  const endpoint = Constant.GET_DINEIN_OUTLETS;
  const BaseUrl = Constant.BASE_URL;
  try {
    const reqBody = {
      resturantType: categoryName
    };

    // Conditionally add the `cities` key if `localityData` is not an empty string
    if (localities.trim() !== "") {
      reqBody.cities = JSON.parse(localities);
    }
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify(reqBody),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GetDineInOutletsTypeAPI = async (categoryName) => {
  const endpoint =
    Constant.GET_DINEIN_OUTLETS + `?resturantType=${categoryName}`;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
